// Third-party imports
import $ from 'jquery';
import Shopify from 'shopify_api';
import { debounce } from './debounce.js';

// Module name
export const MODULE_NAME = 'sort_collection';

export let global_vars = {};

// global arg is expected to be the window object when run in a browser
export function initialize(global) {
    sortCollection(global);
    selectResize();
    selectResizeInit();
}

export function selectResize() {
    $('#sort').addClass('u-invisible');
    const labelWidth = Math.ceil($('.sortBy-label').width());
    const text = $('#sort-by')
        .find('option:selected')
        .text();
    const $dummySelect = $('<select>', { class: 'sortBy-select' }).append(
        $('<option/>').text(text)
    );
    $('#sort-by').after($dummySelect);
    $('#sort-by').width($dummySelect.width() + labelWidth + 10);
    $dummySelect.remove();
    $('#sort').removeClass('u-invisible');
}

export function selectResizeInit() {
    $(function() {
        selectResize();
        $('#sort-by').on('change', function() {
            selectResize();
        });
        window.addEventListener('resize', debounce(selectResize, 200));
    });
}

// global arg is expected to be the window object when run in a browser
export function sortCollection(global) {
    let location = global.location;
    Shopify.queryParams = {};
    if (location.search.length) {
        for (
            let aKeyValue,
                i = 0,
                aCouples = location.search.substr(1).split('&');
            i < aCouples.length;
            i++
        ) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
                Shopify.queryParams[
                    decodeURIComponent(aKeyValue[0])
                ] = decodeURIComponent(aKeyValue[1]);
            }
        }
    }

    let sort_text = global.document.querySelector('.sort-data').dataset.sort;
    let sort_el = global.document.getElementById('sort-by');
    if (sort_el === null) {
        return;
    }

    sort_el.value = sort_text;
    sort_el.addEventListener('change', event => {
        Shopify.queryParams.sort_by = event.currentTarget.value;
        let queryWithJumpToSort = $.param(Shopify.queryParams).replace(
            /\+/g,
            '%20'
        );
        queryWithJumpToSort = '?' + queryWithJumpToSort + '#sort';
        let url = location.origin + location.pathname + queryWithJumpToSort;
        location.href = url;
    });
    selectResize();
}
